import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Apa itu Kenangan.AI?",
      answer: "Kenangan.AI adalah layanan AI memorial berbasis WhatsApp. Layanan ini membantu keluarga menyampaikan informasi duka. Sekaligus mengumpulkan doa, pesan, foto, dan video dari para tamu."
    },
    {
      question: "Bagaimana cara tamu menggunakan Kenangan.AI?",
      answer: "Tamu cukup melakukan langkah berikut: Scan QR Code di rumah duka, WhatsApp akan terbuka otomatis, tamu menerima informasi resmi, dan tamu dapat mengirim doa, pesan, foto, dan video."
    },
    {
      question: "Informasi apa saja yang bisa ditampilkan kepada tamu?",
      answer: "Informasi yang ditampilkan berasal dari keluarga, antara lain: Pengumuman wafat, nama keluarga yang berduka, jadwal ibadah dan prosesi, lokasi rumah duka, pemakaman, atau kremasi, dan ucapan terima kasih dari keluarga."
    },
    {
      question: "Apa saja yang bisa dikirimkan oleh tamu?",
      answer: "Melalui WhatsApp, tamu dapat: Mengirim pesan belasungkawa, mengirim doa dan kata penguatan, mengirim foto dari ponsel masing-masing, dan mengirim video dari ponsel masing-masing."
    },
    {
      question: "Apa yang akan diterima oleh keluarga setelah layanan selesai?",
      answer: "Keluarga akan menerima: Kumpulan pesan dan doa dari tamu, kumpulan foto dari tamu, dan kumpulan video dari tamu. Semua dikompilasi sebagai arsip kenangan digital. Dikirim melalui WhatsApp atau Email, sesuai ukuran file."
    },
    {
      question: "Apakah Kenangan.AI aman dan menjaga kerahasiaan data?",
      answer: "Ya. Kerahasiaan adalah prinsip utama kami. Semua data diserahkan kepada keluarga. Setelah itu, seluruh data dihapus dari sistem. Tidak ada data yang disimpan oleh Kenangan.AI."
    },
    {
      question: "Berapa lama layanan Kenangan.AI aktif?",
      answer: "Layanan aktif selama masa rumah duka. Waktu aktif disesuaikan dengan kebutuhan keluarga. Setelah selesai, layanan dihentikan."
    },
    {
      question: "Apakah keluarga perlu menginstal aplikasi khusus?",
      answer: "Tidak. Kenangan.AI menggunakan WhatsApp. Tidak perlu instal aplikasi tambahan."
    },
    {
      question: "Apakah layanan ini sulit digunakan oleh orang tua atau lansia?",
      answer: "Tidak. Cukup scan QR Code dan membaca pesan WhatsApp. Tampilan dibuat sederhana dan jelas."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-funeral-secondary">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-center gap-3 mb-4">
          <HelpCircle className="text-funeral-gold" size={40} />
          <h2 className="text-4xl md:text-5xl font-serif text-center text-funeral-gold">
            Pertanyaan yang Sering Ditanyakan
          </h2>
        </div>
        <div className="divider"></div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-funeral-dark border border-funeral-border rounded-sm overflow-hidden hover:border-funeral-gold/50 transition-all"
            >
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-funeral-secondary transition-colors group"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-funeral-light font-medium pr-4 group-hover:text-funeral-gold transition-colors">{faq.question}</span>
                <ChevronDown 
                  className={`text-funeral-gold flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}
                  size={20}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 py-4 border-t border-funeral-border bg-funeral-secondary">
                  <p className="text-funeral-light leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
